"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAllPropertyNames = void 0;
function GetAllPropertyNames(prototype) {
    const names = Object.getOwnPropertyNames(prototype);
    const parentPrototype = Object.getPrototypeOf(prototype);
    if (parentPrototype) {
        if (parentPrototype !== Object.prototype) {
            names.push(...GetAllPropertyNames(parentPrototype));
        }
    }
    return names.filter((name, index, self) => self.indexOf(name) === index);
}
exports.GetAllPropertyNames = GetAllPropertyNames;
